import { MODAL_DELETE_ACCOUNT } from '@components/App/Modal/constants'
import { SettingCard, SettingCardRow } from '@components/Dashboard/components'
import { AngleRight } from '@octopus-do/octopus-storybook/icons'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch } from 'react-redux'

import css from './styles.module.css'

export const DeleteAccountSection: React.FC = () => {
  const dispatch = useDispatch()

  const handleOpenDeleteModal = () => {
    dispatch(openModal(MODAL_DELETE_ACCOUNT))
  }

  return (
    <SettingCard title="Delete account">
      <SettingCardRow
        title="Delete my account"
        description="You will be prompted to confirm your account deletion."
      >
        <button className={css.delete_btn} onClick={handleOpenDeleteModal}>
          Delete account <AngleRight />
        </button>
      </SettingCardRow>
    </SettingCard>
  )
}
